import { render, staticRenderFns } from "./cancel-review.vue?vue&type=template&id=7588da3e&scoped=true"
import script from "./cancel-review.vue?vue&type=script&lang=js"
export * from "./cancel-review.vue?vue&type=script&lang=js"
import style0 from "./cancel-review.vue?vue&type=style&index=0&id=7588da3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7588da3e",
  null
  
)

export default component.exports